


import React, { Fragment, useEffect, useState } from "react";
import { useLoading } from "../hooks";
import { makeFailure, makeSuccess, TResult } from "../utils/Result";

type IRenderProps = {
    dataUrl?: string
    failed: boolean;
    loading: boolean;
};

interface RenderPdfDataProps {
    url?: string;
    render: (props: IRenderProps) => any;
};

export const RenderPdfData: React.FC<RenderPdfDataProps> = ({ url, render }) => {
    const {
        loading,
        loadError,
        startLoading,
        loadSuccess,
        loadErrored,
    } = useLoading();

    const [dataUrl, setDataUrl] = useState<TResult<string>>();


    useEffect(() => {
        const loadData = async (url: string) => {
            try {

                var xhr = new XMLHttpRequest();
                xhr.open('GET', url, true);
                xhr.responseType = 'arraybuffer';
                xhr.onload = function (e) {
                    if (this.status == 200) {// eslint-disable-line
                        var blob = new Blob([this.response], { type: "application/pdf" });
                        const dataUrl = window.URL.createObjectURL(blob);
                        setDataUrl(makeSuccess(dataUrl));
                        loadSuccess()
                    }
                };
                xhr.onerror = () => {
                    const error = new Error("Request failed")
                    setDataUrl(makeFailure(error as Error));
                    loadErrored(error.message)
                }
                xhr.send();


            } catch (error) {
              //  console.info(error);
                setDataUrl(makeFailure(error as Error));
                loadErrored((error as Error).message)
            };
        }

        if (!dataUrl && !loading && url) {
            startLoading()
            loadData(url);
        };
    }, [url]); // eslint-disable-line



    return (
        <Fragment>
            {render({
                loading,
                dataUrl: dataUrl?.isSuccess ? dataUrl.value : undefined,
                failed: loadError ? true : (dataUrl && dataUrl.isFailure) ? true : false
            })}
        </Fragment>
    )
};

